const config = {
  ETHERSCAN_API_KEY: process.env.ETHERSCAN_API_KEY || 'default_api_key',
  COINMARKETCAP_API_KEY: process.env.COINMARKETCAP_API_KEY || 'default_api_key',
  CONTRACT_ADDRESS: process.env.CONTRACT_ADDRESS || 'default_address',
  INFURA_PROJECT_ID: process.env.INFURA_PROJECT_ID || 'default_project_id',
};

export default config;

  